import React from 'react';
import './LawyerServicesPage.css';

const LawyerServicesPage = () => {
  return (
    <section className="lawyer-services-page">
      <div className="container">
        <header className="lawyer-services-header">
          <h1>Servicios para Firmas de Abogados</h1>
          <p>
            En GesOps LLC apoyamos a firmas de inmigración con servicios de back office y coordinación administrativa,
            para que tú te enfoques en la práctica legal.
          </p>
        </header>

        <div className="lawyer-services-grid">
          <div className="lawyer-service-card">
            <h2>Servicio de Intake</h2>
            <p>
              Realizamos la recepción inicial de clientes mediante llamadas y entrevistas, representando a tu firma con
              profesionalismo, sin ofrecer orientación legal ni análisis de casos.
            </p>
          </div>

          <div className="lawyer-service-card">
            <h2>Soporte Administrativo</h2>
            <p>
              Apoyamos a tu firma con el envío de contratos, recibos de pago y la recepción administrativa de documentos,
              IDs, pruebas y evidencias indicadas por el abogado.
            </p>
          </div>

          <div className="lawyer-service-card">
            <h2>Servicio al Cliente</h2>
            <p>
              Gestionamos la comunicación administrativa con tus clientes: recordatorios de pagos, seguimiento del estado del
              caso y llamadas de satisfacción, sin ofrecer orientación legal.
            </p>
          </div>

          <div className="lawyer-service-card">
            <h2>Apoyo Operativo</h2>
            <p>
              Contamos con un equipo encargado de brindar asistencia operativa en formularios y mociones bajo las indicaciones
              del abogado.
              <br />
              <br />
              <strong>Disclaimer:</strong> No realizamos análisis ni redacción legal; nuestra labor se limita a la gestión operativa
              indicada por el profesional.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LawyerServicesPage;
